import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextAreaModule } from '../forms/input-textArea/input-textArea.module';
import { MatDialogModule } from '@angular/material/dialog';

//Translation
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from './../translate/translate.service';

import { HttpClient } from '@angular/common/http';

import { DialogConfirmExitComponent } from './dialogConfirmExit/dialogConfirmExit.component';
import { GenericConfirmComponent } from './generic-confirm/generic-confirm.component';
import { DialogGenericInfoComponent } from './dialog-generic-info/dialog-generic-info.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    InputTextAreaModule,
    MatDialogModule
  ],
  declarations: [
    DialogConfirmExitComponent,
    GenericConfirmComponent,
    DialogGenericInfoComponent
  ],
  entryComponents:[
    DialogConfirmExitComponent,
    GenericConfirmComponent,
    DialogGenericInfoComponent
  ],
  exports:[
    DialogConfirmExitComponent,
    GenericConfirmComponent,
    DialogGenericInfoComponent
  ]
})
export class DialogsModule {
}
